// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectEditor_wrapper__7N34P"};